import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpIcon, MicIcon, SparklesIcon } from 'lucide-react';
import { atnaChips } from '../../data/loisirs';
import { InscriptionDialog } from './InscriptionDialog';
interface LoisirsAtnaProps {
  onChip: (chip: string) => void;
}
const PANEL_LAYOUT_ID = 'atna-loisirs-panel';
export function LoisirsAtna({
  onChip
}: LoisirsAtnaProps) {
  const [value, setValue] = useState('');
  const [openedWith, setOpenedWith] = useState<string | null>(null);
  const open = (text: string) => {
    const trimmed = text.trim();
    if (!trimmed) return;
    setOpenedWith(trimmed);
    setValue('');
  };
  return <section aria-labelledby="atna-loisirs-titre" data-id="element-1613" data-mp="546egru65bei">
      <h2 id="atna-loisirs-titre" className="sr-only" data-id="element-1614" data-mp="52v8cld93rk8">
        Recherche assistée par ATNA
      </h2>

      {openedWith !== null ? <div className="h-[66px]" aria-hidden="true" data-id="element-1615" data-mp="srxpzt7vxkeq" /> : <motion.div layoutId={PANEL_LAYOUT_ID} style={{
      borderRadius: 999
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-1616" data-mp="xm1xcdl2bugc">
          <form onSubmit={event => {
        event.preventDefault();
        open(value);
      }} className="flex items-center gap-3 rounded-full border border-slate-200 bg-white py-2.5 pl-5 pr-2.5 shadow-lg shadow-ville-navy/5 transition-colors duration-150 ease-ville focus-within:border-ville-indigo" data-id="element-1617" data-mp="1pi6vvbmtfwcb">
            <SparklesIcon className="h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-1618" data-mp="2d8sygne1woex" />
            <label htmlFor="atna-loisirs" className="sr-only" data-id="element-1619" data-mp="28a9c4lvjpam1">
              Que cherchez-vous ?
            </label>
            <input id="atna-loisirs" type="text" value={value} onChange={event => setValue(event.target.value)} placeholder="Inscrire mon enfant, trouver une activité…" className="min-w-0 flex-1 border-0 bg-transparent py-2.5 text-base text-ville-navy placeholder:text-slate-400 focus:outline-none sm:text-lg" data-id="element-1620" data-mp="2i6cf1ty81da1" />
            <button type="button" aria-label="Dicter votre recherche" className="grid h-10 w-10 shrink-0 place-items-center rounded-full text-slate-500 transition-colors duration-150 ease-ville hover:bg-slate-100 hover:text-ville-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1621" data-mp="1hh94yztombk0">
              <MicIcon className="h-5 w-5" aria-hidden="true" data-id="element-1622" data-mp="1wcytp5q952sf" />
            </button>
            <button type="submit" aria-label="Envoyer la recherche" className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-ville-lime text-ville-navy transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1623" data-mp="20etxqhzkhu9w">
              <ArrowUpIcon className="h-5 w-5" aria-hidden="true" data-id="element-1624" data-mp="2k55kzqh4ejkz" />
            </button>
          </form>
        </motion.div>}

      <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-3" data-id="element-1625" data-mp="8exw7brmuizv">
        <p className="text-xs font-semibold uppercase tracking-wider text-ville-indigo" data-id="element-1626" data-mp="3gwbynih0dmt">Propulsé par ATNA</p>
        <ul className="-mx-5 flex snap-x gap-2.5 overflow-x-auto px-5 sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0" data-id="element-1627" data-mp="3uql9xcddkve7">
          <li className="shrink-0 snap-start" data-id="element-1628" data-mp="r7s7nvq1rszc">
            <button type="button" onClick={() => open('Inscrire mon enfant')} className="rounded-full border border-ville-navy bg-ville-navy px-4 py-2 text-sm font-semibold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1629" data-mp="r6gwvby6pkyq">
              Inscrire mon enfant
            </button>
          </li>
          {atnaChips.map(chip => <li key={chip} className="shrink-0 snap-start" data-id="element-1630" data-mp="1568hhvj7hzlp">
              <button type="button" onClick={() => {
            if (chip === 'Trouver une activité') {
              open(chip);
              return;
            }
            setValue(chip);
            onChip(chip);
          }} className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1631" data-mp="ppa3mq1250dn">
                {chip}
              </button>
            </li>)}
        </ul>
      </div>

      <AnimatePresence data-id="element-1632" data-mp="13nqbwlekiyxw">
        {openedWith !== null && <InscriptionDialog key="atna-loisirs-inscription" initialText={openedWith} layoutId={PANEL_LAYOUT_ID} onClose={() => setOpenedWith(null)} data-id="element-1633" data-mp="1redovl3ccerb" />}
      </AnimatePresence>
    </section>;
}